import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getDataSuccess: (data) => ({ data }),
  getData:
    (search, paging, filterOption = {}, sortOption = {}) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().package.paging;
      let { result, status } = await Api.post(`packages/filter`, {
        pageIndex: pagingData.pageIndex,
        pageSize: pagingData.pageSize,
        search,
        ...filterOption,
        ...sortOption,
      });
      status === 200 && packageDispatcher.getDataSuccess(result);
    },
  getPackagesData:
    () =>
    async ({ Api }) => {
      let profilesApi = Api.get(`profiles`);
      let [profilesRes] = await Promise.all([profilesApi]);
      if (profilesRes.status === 200)
        packageDispatcher.getDataSuccess(profilesRes.result.list || []);
    },
  getAllProfiles:
    (callback) =>
    async ({ Api }) => {
      let { result, status } = await Api.get(`profiles`);
      status === 200 && callback && callback(result.list);
    },
  getAllPackages:
    (callback) =>
    async ({ Api }) => {
      let { result, status } = await Api.post(`packages/filter`, {});
      status === 200 && callback && callback(result.list);
    },
  getProfileById:
    (id, callbackSuccess) =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`profiles/${id}`);
      if (status === 200) {
        callbackSuccess(result);
      }
    },
  addPackage:
    (payload, callbackSuccess) =>
    async ({ Api }) => {
      const { result, status } = await Api.post(`packages`, payload);
      if (status === 200) {
        callbackSuccess && callbackSuccess(result);
      }
    },
  getPackageById:
    (id, callbackSuccess) =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`packages/${id}`);
      if (status === 200) {
        callbackSuccess && callbackSuccess(result);
      }
    },
  updatePackage:
    (id, payload, callbackSuccess) =>
    async ({ Api }) => {
      const { result, status } = await Api.put(`packages/${id}`, payload);
      if (status === 200) {
        callbackSuccess && callbackSuccess(result);
      }
    },
  deletePackage:
    (id, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { status } = await Api.delete(`packages/${id}`);
      if (status === 200) {
        callbackSuccess && callbackSuccess();
        customToast('success', 'Package was deleted');
      }
    },
};

const packageDispatcher = synthesize('package', mapDispatchToAC);
export default packageDispatcher;
